import { Component, OnInit } from '@angular/core';
import { NavService } from 'src/app/_services/nav.service';
import { FilesControlService } from 'src/app/_services/files-control.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'files-control-detail',
  templateUrl: './files-control-detail.component.html',
  styleUrls: ['./files-control-detail.component.css'],
})
export class FilesControlDetailComponent implements OnInit {
  data: { title: 'Reports' };
  isLoading: boolean = true;
  currentTab: number = 1;
  id;
  file;
  isSuperAdmin: boolean;

  // tslint:disable-next-line: max-line-length
  constructor(
    private navService: NavService,
    public filesControlService: FilesControlService,
    public activatedRoute: ActivatedRoute,
    public route: Router,
    public authService: AuthService,
    private location: Location
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    this.authService.isSuperAdmin().subscribe((res) => {
      this.isSuperAdmin = !!res;
    });
    this.getData();
    this.selectedNavItem({
      parent: 'menu.reports.reports',
      child: 'menu.utilities.fileTraceability',
      description: 'pageDescriptions.filesControl',
    });
    // Min Date
  }

  getData() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.filesControlService
        .getFileInfoById({ id: this.id })
        .subscribe((res) => {
          this.file = res.body;
        });
    });
  }

  goBack() {
    this.location.back();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
